<template>
  <div class="director-home" v-loading="loading">
    <div class="yn-biz-header">
      <span class="yn-biz-title">现场部工作台</span>
      <span class="text-muted">现场部主任 · 采样审核 / 现场表单</span>
    </div>

    <el-row :gutter="16" class="stat-row">
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card stat-card--warn" @click.native="goPickAudit()">
          <div class="stat-num">{{ summary.pickAudit || 0 }}</div>
          <div class="stat-label">待审采样</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card" @click.native="goBatchContract()">
          <div class="stat-num">{{ summary.todoCount || 0 }}</div>
          <div class="stat-label">待办总数</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card" @click.native="$router.push('/pick/calendar')">
          <div class="stat-num"><i class="el-icon-date" /></div>
          <div class="stat-label">采样日历</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="section-card">
      <div slot="header">待审采样（置顶）</div>
      <div v-if="!(summary.pickAuditItems || []).length" class="text-muted empty-tip">暂无 App 提交待审</div>
      <div
        v-for="row in summary.pickAuditItems || []"
        :key="row.id"
        class="list-row"
        @click="openRow(row)"
      >
        <div>
          <div class="row-title">{{ row.caseName }}</div>
          <div class="text-muted">{{ row.xmbh }} · {{ row.prevUser }}</div>
        </div>
        <div class="row-right">
          <el-tag size="mini" type="warning">待审核</el-tag>
          <div class="text-muted">{{ row.relatedForms || '现场采样表' }}</div>
        </div>
      </div>
    </el-card>

    <div class="quick-bar">
      <el-button type="primary" size="small" @click="goBatchContract()">批量现场采样</el-button>
      <el-button size="small" @click="$router.push('/todo')">待办箱</el-button>
      <el-button size="small" @click="$router.push('/pick/calendar')">采样日历</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { subscribeTodoSync } from '@/utils/todoSync'

export default {
  name: 'FieldDirectorHome',
  data() {
    return {
      loading: false,
      summary: {}
    }
  },
  mounted() {
    this.load()
    this.startAutoRefresh()
  },
  activated() {
    this.load()
    this.startAutoRefresh()
  },
  deactivated() {
    this.stopAutoRefresh()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
  },
  methods: {
    startAutoRefresh() {
      this.stopAutoRefresh()
      this._unsubTodo = subscribeTodoSync(() => this.load(true))
    },
    stopAutoRefresh() {
      if (typeof this._unsubTodo === 'function') {
        this._unsubTodo()
        this._unsubTodo = null
      }
    },
    async load(silent) {
      if (!silent) this.loading = true
      try {
        const res = await api.get('yn_director_home')
        this.summary = res.data || {}
      } catch (e) {
        if (!silent) this.$message.error('加载工作台失败')
      } finally {
        if (!silent) this.loading = false
      }
    },
    goPickAudit() {
      const items = this.summary.pickAuditItems || []
      if (items.length && items[0].route) {
        this.openRow(items[0])
      } else {
        this.goBatchContract()
      }
    },
    goBatchContract() {
      this.$router.push('/pick/batch-contract').catch(() => {})
    },
    openRow(row) {
      if (!row || !row.route) return
      const r = String(row.route)
      const qi = r.indexOf('?')
      if (qi >= 0) {
        const path = r.slice(0, qi)
        const query = {}
        r.slice(qi + 1).split('&').forEach(pair => {
          const eq = pair.indexOf('=')
          if (eq < 0) return
          query[pair.slice(0, eq)] = decodeURIComponent(pair.slice(eq + 1))
        })
        this.$router.push({ path, query }).catch(() => {})
      } else {
        this.$router.push(r).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.director-home { padding: 0 4px; }
.stat-row { margin: 16px 0; }
.stat-card { cursor: pointer; text-align: center; }
.stat-card--warn .stat-num { color: #e6a23c; }
.stat-num { font-size: 28px; font-weight: 700; }
.stat-label { color: #909399; margin-top: 6px; }
.section-card { margin-top: 8px; }
.text-muted { color: #909399; font-size: 12px; }
.list-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}
.list-row:hover { background: #f5f7fa; }
.row-title { font-weight: 600; }
.row-right { text-align: right; }
.empty-tip { padding: 24px 0; text-align: center; }
.quick-bar { margin-top: 16px; }
</style>
